import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export default function Promptdialog({ open, handleClose, prompt }) {
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>Generated Prompt</DialogTitle>
            <DialogContent>
                <div
                    dangerouslySetInnerHTML={{ __html: prompt }}
                    style={{ whiteSpace: 'pre-wrap', fontSize: '1rem' }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
